'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = copyProps;
function copyProps(inProps) {
  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // copys props into a new object
  // ignore is an array of props you don't want copied
  // ignore VSTComponent necessary props
  ignore.push('primary');
  ignore.push('accent');
  ignore.push('theme');
  ignore.push('themeMap');

  var props = {};
  var key = void 0;
  for (key in inProps) {
    if (inProps.hasOwnProperty(key) && !ignore.includes(key)) {
      props[key] = inProps[key];
    }
  }
  return props;
}


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/utils/copy-props.js
 **/